import React, { useState, useEffect } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ t, lang, setLang }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const toggleLanguage = () => {
    setLang(lang === 'id' ? 'en' : 'id');
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-amber-600 rounded-lg flex items-center justify-center">
              <span className="text-black font-bold text-xl">K</span>
            </div>
            <span className="text-xl font-bold text-white tracking-wider">KETUA</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-300 hover:text-amber-400 transition-colors">
              {t.nav.home}
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-amber-400 transition-colors">
              {t.nav.services}
            </button>
            <button onClick={() => scrollToSection('styles')} className="text-gray-300 hover:text-amber-400 transition-colors">
              {t.nav.styles}
            </button>
            <button onClick={() => scrollToSection('gallery')} className="text-gray-300 hover:text-amber-400 transition-colors">
              {t.nav.gallery}
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-300 hover:text-amber-400 transition-colors">
              {t.nav.testimonials}
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-amber-400 transition-colors">
              {t.nav.contact}
            </button>
          </nav>

          {/* CTA & Language Switcher */}
          <div className="hidden md:flex items-center space-x-4">
            <Button
              onClick={toggleLanguage}
              variant="ghost"
              size="sm"
              className="text-gray-300 hover:text-amber-400 hover:bg-amber-400/10"
            >
              <Globe className="w-4 h-4 mr-2" />
              {lang.toUpperCase()}
            </Button>
            <Button
              onClick={() => scrollToSection('booking')}
              className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black font-semibold"
            >
              {t.nav.book}
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-md py-4 space-y-4">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left px-4 py-2 text-gray-300 hover:text-amber-400 transition-colors">
              {t.nav.home}
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-2 text-gray-300 hover:text-amber-400 transition-colors">
              {t.nav.services}
            </button>
            <button onClick={() => scrollToSection('styles')} className="block w-full text-left px-4 py-2 text-gray-300 hover:text-amber-400 transition-colors">
              {t.nav.styles}
            </button>
            <button onClick={() => scrollToSection('gallery')} className="block w-full text-left px-4 py-2 text-gray-300 hover:text-amber-400 transition-colors">
              {t.nav.gallery}
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left px-4 py-2 text-gray-300 hover:text-amber-400 transition-colors">
              {t.nav.testimonials}
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-4 py-2 text-gray-300 hover:text-amber-400 transition-colors">
              {t.nav.contact}
            </button>
            <div className="px-4 pt-2 space-y-2">
              <Button
                onClick={toggleLanguage}
                variant="outline"
                className="w-full border-amber-400 text-amber-400 hover:bg-amber-400 hover:text-black"
              >
                <Globe className="w-4 h-4 mr-2" />
                {lang === 'id' ? 'English' : 'Bahasa'}
              </Button>
              <Button
                onClick={() => scrollToSection('booking')}
                className="w-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black font-semibold"
              >
                {t.nav.book}
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
